import React from 'react';
import CustomSwitch from 'app/components/CustomSwitch';
import { Box, Divider, FormControl, Typography } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import { black1, grey10, grey9 } from 'app/components/ThemeProvider/colors';
import AZFlag from 'app/components/Icons/AZFlag';
import USFlag from 'app/components/Icons/USFlag';
import logger from 'app/utils/logger';
import FieldError from 'app/components/FieldError';

interface Props {
  control?: any;
  register?: any;
  errors?: any;
  fromAccountConversion?: any;
  toAccountConversion?: any;
  handleChangeFromConversion?: any;
  handleChangeToConversion?: any;
  selectedFromAccountConversion?: any;
  selectedToAccountConversion?: any;
  commissionConversion?: any;
  handleChangeCommissionConversion?: any;
  checkIndividualConversion?: any;
  handleSwitchIndividualConversion?: any;
  rates?: any;
  selectedRates?: any;
  handleSelectRates?: any;
  handleChangeFromAmountConversion?: any;
  fromAmountConversion?: any;
  toAmountConversion?: any;
  handleChangeToAmountConversion?: any;
  handleSwitchCurrencyConversion?: any;
  dataForm?: any;
  commissionOption?: any;
  individualRates?: any;
  handleChangeIndividualRate?: any;
}

const GeneralDetailsConversion = (props: Props) => {
  const {
    control,
    errors,
    register,
    toAccountConversion,
    fromAccountConversion,
    handleChangeFromConversion,
    handleChangeToConversion,
    selectedFromAccountConversion,
    handleChangeCommissionConversion,
    handleSwitchIndividualConversion,
    checkIndividualConversion,
    selectedToAccountConversion,
    commissionConversion,
    rates,
    selectedRates,
    handleSelectRates,
    handleChangeFromAmountConversion,
    fromAmountConversion,
    toAmountConversion,
    handleChangeToAmountConversion,
    handleSwitchCurrencyConversion,
    dataForm,
    commissionOption,
    individualRates,
    handleChangeIndividualRate,
  } = props;

  logger.log('fromAccountConversion');
  logger.log(fromAccountConversion);

  return (
    <Box>
      <CustomSwitch
        title={'Fərdi məzənnə ilə'}
        sx={{ mb: '36px' }}
        checked={checkIndividualConversion}
        handleToggle={handleSwitchIndividualConversion}
      />
      {checkIndividualConversion && (
        <Box sx={{ display: 'flex', gap: '28px' }}>
          {/*<FormControl>*/}
          {/*  <CustomSelect*/}
          {/*    title={'Valyuta'}*/}
          {/*    placeholder={'Valyuta'}*/}
          {/*    options={rates}*/}
          {/*    control={control}*/}
          {/*    rest={{ ...register('valyuta') }}*/}
          {/*    onChange={handleSelectRates}*/}
          {/*    value={selectedRates}*/}
          {/*  />*/}
          {/*</FormControl>*/}
          <FormControl
            sx={{
              '@media screen and (max-width: 768px)': {
                width: '100%',
              },
            }}
          >
            <CustomInput
              title={'Fərdi məzənnə'}
              placeholder={'Fərdi məzənnə'}
              rest={{ ...register('customerRate') }}
              isValid={errors.cusomerRate !== undefined || dataForm?.errors?.fields.customer_rate !== undefined}
              value={individualRates}
              handleChange={handleChangeIndividualRate}
            />
            <FieldError
              error={
                errors.customerRate
                  ? errors.customerRate
                  : dataForm?.errors?.fields.customer_rate && { message: dataForm?.errors?.fields.customer_rate }
              }
            />
          </FormControl>
        </Box>
      )}
      <Divider sx={{ mb: '24px', mt: '24px' }} />
      <Box
        sx={{
          display: 'flex',
          gap: '48px',
          alignItems: 'center',
          mb: '36px',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
            gap: '20px',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            height: '206px',
            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <FormControl>
            <CustomSelect
              title={'Məxaric hesabı'}
              placeholder={'Məxaric hesabı'}
              options={fromAccountConversion}
              control={control}
              value={selectedFromAccountConversion}
              rest={{ ...register('fromAccount') }}
              onChange={handleChangeFromConversion}
              isValid={errors.fromAccount !== undefined}
            />
            <FieldError error={errors.fromAccount} />
          </FormControl>
          <FormControl>
            <CustomInput
              title={'Məbləğ'}
              placeholder={'Məbləğ'}
              value={fromAmountConversion}
              handleChange={handleChangeFromAmountConversion}
              rest={{ ...register('amountFrom') }}
              adornment={
                selectedFromAccountConversion !== undefined && (
                  <img
                    src={rates?.find((item: any) => item.value === selectedFromAccountConversion?.currency)?.icon}
                    alt="logo"
                    width="24"
                    height="16"
                  />
                )
              }
              isValid={errors.amountFrom !== undefined || dataForm?.error?.fields.amount !== undefined}
            />
            <FieldError
              error={
                errors.amountFrom
                  ? errors.amountFrom
                  : dataForm?.error?.fields.amount && { message: dataForm?.error?.fields.amount }
              }
            />
          </FormControl>
        </Box>
        <Box
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            background: grey9,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

            '&:hover': {
              background: 'rgba(255, 199, 44, 0.85)',
              cursor: 'pointer',
            },
          }}
          onClick={handleSwitchCurrencyConversion}
        >
          <SwitchIcon sx={{ width: '24px', height: '24px' }} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            height: '206px',
            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <FormControl>
            <CustomSelect
              title={'Alan hesab'}
              placeholder={'Alan hesab'}
              options={toAccountConversion}
              control={control}
              value={selectedToAccountConversion}
              rest={{ ...register('toAccount') }}
              onChange={handleChangeToConversion}
              isValid={errors.toAccount}
            />
            <FieldError error={errors.toAccount} />
          </FormControl>
          <CustomInput
            title={'Məbləğ'}
            placeholder={'Məbləğ'}
            value={toAmountConversion}
            handleChange={handleChangeToAmountConversion}
            adornment={
              selectedToAccountConversion !== undefined && (
                <img
                  src={rates?.find((item: any) => item.value === selectedToAccountConversion?.currency)?.icon}
                  alt="logo"
                  width="24"
                  height="16"
                />
              )
            }
          />
        </Box>
      </Box>
      {/*<Box*/}
      {/*  sx={{*/}
      {/*    display: 'flex',*/}
      {/*    gap: '72px',*/}
      {/*    p: '16px 28px',*/}
      {/*    width: '784px',*/}
      {/*    background: grey10,*/}
      {/*    borderRadius: '8px',*/}
      {/*    mb: '36px',*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Box>*/}
      {/*    <Typography sx={{ color: 'rgba(20, 25, 31, 0.56)' }}>Göndərilən vəsait</Typography>*/}
      {/*    <Typography sx={{ color: black1, fontWeight: '600' }}>56.00 $</Typography>*/}
      {/*  </Box>*/}
      {/*  <Box>*/}
      {/*    <Typography sx={{ color: 'rgba(20, 25, 31, 0.56)' }}>Əməliyyat məzənnəsi</Typography>*/}
      {/*    <Typography sx={{ color: black1, fontWeight: '600' }}> 1 $ = 1.7020 ₼</Typography>*/}
      {/*  </Box>*/}
      {/*  <Box>*/}
      {/*    <Typography sx={{ color: 'rgba(20, 25, 31, 0.56)' }}>Komissiya</Typography>*/}
      {/*    <Typography sx={{ color: black1, fontWeight: '600' }}> 0.14 ₼</Typography>*/}
      {/*  </Box>*/}
      {/*</Box>*/}
      <FormControl
        sx={{
          '@media screen and (max-width: 768px)': {
            width: '100%',
          },
        }}
      >
        <CustomSelect
          title={'Komissiyanın məxaric hesabı'}
          placeholder={'Komissiyanın məxaric hesabını seçin'}
          options={commissionOption}
          control={control}
          rest={{ ...register('commission') }}
          value={commissionConversion}
          onChange={handleChangeCommissionConversion}
          isValid={errors.commission}
        />
        <FieldError error={errors.commission} />
      </FormControl>
    </Box>
  );
};

export default GeneralDetailsConversion;
